import { Button, ButtonVariant } from "@swivl-mono/ui";
import * as React from "react";
import { FaCopy, FaTrashAlt } from "react-icons/fa";

import "../InspectorPanel.scss";

interface InspectorFooterProps {
  editor?: any;
  node?: any;
  deleteNode?: any;
  duplicateNode?: (nodeId: string) => void;
  canDuplicate?: boolean;
}

export default class InspectorFooter extends React.Component<InspectorFooterProps, any> {
  constructor(props: InspectorFooterProps) {
    super(props);
    this.state = { showConfirm: false };
    this.deletePressed = this.deletePressed.bind(this);
    this.cancelPressed = this.cancelPressed.bind(this);
    this.deleteConfirmed = this.deleteConfirmed.bind(this);
    this.duplicatePressed = this.duplicatePressed.bind(this);
    this.state = { showConfirm: false };
  }

  deletePressed() {
    this.setState({ showConfirm: true });
  }
  cancelPressed() {
    this.setState({ showConfirm: false });
  }
  deleteConfirmed() {
    this.props.deleteNode(this.props.node);
  }
  duplicatePressed() {
    if (this.props.duplicateNode && this.props.node) {
      this.props.duplicateNode(this.props.node.id);
    }
  }
  componentWillReceiveProps(nextProps: any) {
    this.setState({ showConfirm: false });

    if (
      !nextProps.editor ||
      !nextProps.editor.state.selectedNode ||
      (nextProps.editor.state.selectedNode &&
        this.props.editor.state.selectedNode &&
        nextProps.editor.state.selectedNode.id != this.props.editor.state.selectedNode.id)
    ) {
      this.setState({ showConfirm: false });
    }
  }
  render() {
    if (!this.props.deleteNode) {
      return null;
    }
    if (this.props.node) {
      let content;
      if (!this.state.showConfirm) {
        content = (
          <>
            {this.props.canDuplicate && this.props.duplicateNode && (
              <div className="duplicateNodeButton flex items-center gap-2" onClick={this.duplicatePressed}>
                <FaCopy /> DUPLICATE NODE
              </div>
            )}
            <div className="deleteNodeButton flex items-center gap-2" onClick={this.deletePressed}>
              <FaTrashAlt /> DELETE THIS NODE
            </div>
          </>
        );
      } else {
        content = (
          <div className="confirmView">
            <div className="confirmText">ARE YOU SURE?</div>
            <div className="deleteOptions flex gap-2">
              <Button variant={ButtonVariant.GHOST} onClick={this.cancelPressed} style={{ fontWeight: 400 }}>
                NO, CANCEL
              </Button>
              <Button variant={ButtonVariant.GHOST} onClick={this.deleteConfirmed} style={{ fontWeight: 400, color: "var(--color-red-600)" }}>
                YES, DELETE
              </Button>
            </div>
          </div>
        );
      }

      return <div className="inspectorFooter flex flex-col items-center">{content}</div>;
    }

    return null;
  }
}
